import { render, staticRenderFns } from "./MSecondaryDomainIndex.vue?vue&type=template&id=a3b9ab88&"
import script from "./MSecondaryDomainIndex.vue?vue&type=script&lang=ts&"
export * from "./MSecondaryDomainIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports